import React from 'react';

/** A grocery item's tags as small chips, for a list row; nothing when it has none. */
export default function ItemTags({ tags }) {
	if(!tags || !tags.length) {
		return null;
	}
	return (
		<span className='grocery_item_tags'>
			{tags.map((tag) => <span key={tag} className='grocery_item_tag'>{tag}</span>)}
		</span>
	);
}
